// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2026 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { orderUploadStyles } from "@insite/content-library/Components/OrderUpload";
import { fontConfig } from "@vanmeter/XDL/constants";
import { xScreen } from "@vanmeter/XDL/Utilities";
import { css } from "styled-components";

orderUploadStyles.downloadTemplateButton = {
    variant: "secondary",
    css: css`
        margin-bottom: 12px;
        ${xScreen("lte", "xs")} {
            width: 100%;
        }
    `,
};

orderUploadStyles.fileUploader = {
    buttonProps: {
        variant: "secondary",
        css: css`
            line-height: ${fontConfig.regular.lineHeight};
            padding-top: 2px;
        `,
    },
};

orderUploadStyles.includeFirstRowCheckbox = {
    css: css`
        margin: 15px 0;
        display: flex;
    `,
};

orderUploadStyles.uploadFileButton = {
    css: css`
        float: right;
        margin-left: 12px;
        ${xScreen("lte", "xs")} {
            margin: 0 0 12px 0;
            width: 100%;
        }
    `,
};

orderUploadStyles.mainWrapper = {
    css: css`
        width: 100%;
    `,
};

orderUploadStyles.spinner = {
    size: 12,
    css: css`
        margin-right: 8px;
    `,
};

orderUploadStyles.uploadFileButtonLabel = orderUploadStyles.uploadingButtonLabel = {};

orderUploadStyles.orderCancellationSuccessfulText = {
    color: "success",
    variant: "h6",
};

orderUploadStyles.cancelUploadButton = {
    variant: "primary",
    buttonType: "outline",
    css: css`
        float: right;
    `,
};
